import _ from 'lodash'
import api from './Api'

export const searchNSCustomersDebounced = value => {
  return new Promise((resolve, reject) =>
    _searchNSCustomersDebounced({ value, resolve, reject }),
  )
}

const _searchNSCustomersDebounced = _.debounce(
  async ({ value, resolve, reject }) => {
    try {
      const response = await api.get(`/netsuitecustomers?nsCustomerId=${value}`)
      resolve(response)
    } catch (err) {
      reject(err)
    }
  },
  300,
)

export const formatSiteForSchoolLookUp = school => {
  const { address } = school
  const { city, country, region } = address || {}
  const nsCustomerId =
    school.nsCustomerId ||
    (school.netSuiteCustomer && school.netSuiteCustomer.nsCustomerId) ||
    null
  const hasNsCustomerId = !!nsCustomerId || school.netsuiteCustomerId !== 0

  return {
    city,
    companyName: hasNsCustomerId ? school.companyName || school.name : '',
    country,
    netsuiteCustomerId: school.netsuiteCustomerId || 0,
    nsCustomerId: nsCustomerId || '',
    region,
    organizationName: !hasNsCustomerId
      ? school.organizationName || school.name
      : '',
  }
}

export const formatNetsuiteCustomerForSchoolLookUp = netsuiteCustomer => {
  const { address } = netsuiteCustomer
  const { city, country, region } = address || {}

  const hasNsCustomerId = !!netsuiteCustomer.nsCustomerId

  return {
    city,
    companyName: hasNsCustomerId ? netsuiteCustomer.companyName : '',
    country,
    netsuiteCustomerId: hasNsCustomerId ? netsuiteCustomer.id : 0,
    nsCustomerId: netsuiteCustomer.nsCustomerId || '',
    region,
    organizationName: hasNsCustomerId ? netsuiteCustomer.companyName : '',
  }
}



// WEBPACK FOOTER //
// ./src/lib/editNetSuite.js